export default (date) => {
	return new Date(date).getTime() / 1000
}
